import { Reveal, Eyebrow } from "../components/Reveal";

const CHAPTERS = [
  "I served this country and came home with one mission. To use everything my service gave me to help the people around me.",
  "I was given an opportunity by the veterans association to work toward my VA accreditation. To earn it I need to show a proof of concept, documented cases of families I have genuinely helped. So I am using every military benefit available to make this a no-brainer for you.",
  "The more people I help, the faster I reach my accreditation goal. You help me. I help you. We both win.",
  "I am not here to sell you something. I am here because I served so that families like yours would never have to worry about losing everything they built.",
  "As a retired veteran I also have access to military legal benefits. Every file I take on receives a legal review at no additional charge. That protection is built into everything I do.",
];

const MISSION = [
  "Everything I offer comes from one place. My military service and my mission to protect families the way I protected this country.",
  "Wealthy families have had access to trusts, asset protection, and legal structures for generations. Most everyday families never knew these tools existed or thought they were too expensive to reach.",
  "That changes here. Because of what I earned through 20 years of service you get access to the same protection. At a price that makes sense.",
  "Your family deserves real protection. Not promises. Not paperwork that sits in a drawer. A structure that actually works when life gets hard.",
];

export const Story = () => (
  <section className="bg-parchment text-ink py-24 sm:py-36" data-testid="story-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-4 lg:sticky lg:top-32 self-start">
          <Reveal>
            <Eyebrow>U.S. Combat Veteran, Retired</Eyebrow>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-6 leading-[1.06]">
              Why I Am <em className="text-goldeep italic">Doing This</em>
            </h2>
            <div className="mt-10 rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="/images/founder-flag.jpg"
                alt="Proud hands holding a neatly folded American flag"
                className="w-full h-72 sm:h-96 object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <div className="space-y-12 sm:space-y-14">
            {CHAPTERS.map((text, i) => (
              <Reveal key={i} delay={0.05 * i}>
                <div className="flex gap-6 sm:gap-10 items-start border-b border-ink/10 pb-12 sm:pb-14">
                  <span className="font-display text-goldeep/50 text-2xl sm:text-3xl italic shrink-0 leading-none pt-1">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <p className={`leading-relaxed ${i === 0 ? "font-display text-2xl sm:text-3xl text-ink" : "text-ink/75 text-base sm:text-lg"}`}>
                    {text}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal className="mt-16 sm:mt-20">
            <div className="bg-ink text-cream rounded-3xl p-8 sm:p-14 relative overflow-hidden">
              <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-gold/10 blur-3xl" aria-hidden="true" />
              <Eyebrow light>The Mission</Eyebrow>
              <div className="mt-8 space-y-6">
                {MISSION.map((text, i) => (
                  <p key={i} className={i === 0 ? "font-display text-xl sm:text-2xl leading-snug text-cream" : "text-cream/70 text-base sm:text-lg leading-relaxed"}>
                    {text}
                  </p>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
